export const help = {
  'help.diagram': 'Схема обработки; шаги также описаны в статье.',
  'help.diagramLoading': 'Подготовка схемы…',
  'help.diagramFailed': 'Не удалось показать схему. Шаги описаны в статье и в исходной разметке ниже.',
  'help.diagramSource': 'Разметка схемы (Mermaid)',
  'help.copyContext': 'Скопировать контекст раздела для агента',
  'help.copyContextDetail': 'Копирует раздел и безопасные ссылки входа. Без идентификаторов пациента, приёма и медицинского текста.',
  'help.contextCopied': 'Контекст раздела скопирован.',
  'help.contextCopyFailed': 'Не удалось скопировать контекст. Попробуйте ещё раз.',
  'help.title': "Справка",
  'help.description': "Руководство по клиническим записям и файлам пациента.",
  'help.downloadArchive': "Скачать всю справку (ZIP)",
  'help.downloadingArchive': "Подготовка архива…",
  'help.archiveFailed': "Не удалось скачать архив. Повторите попытку.",
  'help.archiveForbidden': "У вашей учётной записи нет доступа к скачиванию архива.",
  'help.open': "Справка по этому экрану",
  'help.center': "Открыть раздел справки",
  'help.search': "Поиск по руководству",
  'help.topics': "Темы",
  'help.related': "Справка по разделу",
  'help.all': "Все темы",
  'help.loading': "Загрузка справки…",
  'help.failed': "Не удалось загрузить справку.",
  'help.unavailable': "Эта тема недоступна для вашей клиники или учётной записи.",
  'help.retry': "Повторить",
  'help.empty': "Подходящих тем нет.",
  'help.notReady': "Для этой страницы справка пока не готова.",
  'help.fallback': "Перевод пока недоступен — статья показана в оригинале: {language}.",
  'help.internal': "Для служебного пользования",
  'help.contents': "На этой странице",
  'help.revision': "Редакция {revision}",
  'help.language': "Язык статьи",
} as const
